import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader } from 'lucide-react';
import { verifyPhonePePayment } from '../lib/phonepe';
import { supabase } from '../lib/supabase';

const CheckoutVerify = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        const transactionId = searchParams.get('transactionId');
        if (!transactionId) {
          throw new Error('Transaction ID not found');
        }

        const result = await verifyPhonePePayment(transactionId);

        if (result.success) {
          // Update order status
          const { error: updateError } = await supabase
            .from('orders')
            .update({
              payment_status: 'completed',
              status: 'processing',
              payment_id: transactionId,
              payment_timestamp: new Date().toISOString()
            })
            .eq('payment_id', transactionId);

          if (updateError) throw updateError;

          navigate('/checkout/success');
        } else {
          throw new Error(result.message || 'Payment verification failed');
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Payment verification failed');
        setTimeout(() => navigate('/checkout'), 3000);
      } finally {
        setVerifying(false);
      }
    };

    verifyPayment();
  }, [searchParams, navigate]);

  if (verifying) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Loader className="h-8 w-8 animate-spin text-yellow-500 mx-auto mb-4" />
          <p className="text-gray-600">Verifying your payment...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-500 mb-4">{error}</div>
          <p className="text-gray-600">Redirecting back to checkout...</p>
        </div>
      </div>
    );
  }

  return null;
};

export default CheckoutVerify;